import React, { useMemo, useState } from "react";

import { Item } from "./Models/Item";
import { LocalizationMessages } from "../../localization/messages";
import { MenuItem } from "./MenuItem";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { MenuActionCreators } from "../../redux/action-creators";
import { useSelector } from "react-redux";
import { MenuSelectors } from "../../redux/selectors";
import { CATEGORY_CONSTANTS } from "../../constants";

export const KambiMobileExpandMenuItem = ({ trackingInfo }) => {
  const [showMore, setShowMore] = useState(false);
  const sportCategories = useSelector(MenuSelectors.sportCategories);
  const dispatch = useDispatch();

  const onClick = event => {
    event.preventDefault();
    event.stopPropagation();
    setShowMore(!showMore);
    dispatch(
      MenuActionCreators.setNumberOfDisplayedItems(
        !showMore
          ? sportCategories?.length
          : CATEGORY_CONSTANTS.NUMBER_OF_ITEMS_MOBILE_LOW
      )
    );

    return false;
  };

  const item = useMemo(
    () =>
      new Item({
        title: showMore
          ? LocalizationMessages.seeLess
          : LocalizationMessages.seeMore,
        ID: showMore ? "SeeLess" : "SeeMore"
      }),
    [showMore]
  );
  return (
    <MenuItem
      item={item}
      key={showMore ? "see-less" : "see-more"}
      hasArrow
      onClick={onClick}
      dataTestId={showMore ? "see-less" : "see-more"}
      className={showMore ? "seeLess" : "seeMore"}
      trackingInfo={trackingInfo}
      hasIcon={false}
    />
  );
};

KambiMobileExpandMenuItem.propTypes = {
  trackingInfo: PropTypes.object
};
